import { render, staticRenderFns } from "./SimpleRgb.vue?vue&type=template&id=f31a0f4c&scoped=true&lang=pug"
import script from "./SimpleRgb.vue?vue&type=script&lang=ts"
export * from "./SimpleRgb.vue?vue&type=script&lang=ts"
import style0 from "./SimpleRgb.vue?vue&type=style&index=0&id=f31a0f4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31a0f4c",
  null
  
)

export default component.exports